import { render, staticRenderFns } from "./TvodPrivacyPolicy.vue?vue&type=template&id=f1477212&scoped=true&"
import script from "./TvodPrivacyPolicy.vue?vue&type=script&lang=js&"
export * from "./TvodPrivacyPolicy.vue?vue&type=script&lang=js&"
import style0 from "./TvodPrivacyPolicy.vue?vue&type=style&index=0&id=f1477212&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1477212",
  null
  
)

component.options.__file = "TvodPrivacyPolicy.vue"
export default component.exports